import {AlpineComponent} from 'alpinejs';
import Swiper from 'swiper';
import * as SwiperModules from 'swiper/modules';
import {PlayerEvents} from '../plugins/video-player/Player';

type PageHeroData = {}

export default (): AlpineComponent<PageHeroData> => ({
  init() {
    const swiperEl = this.$root.querySelector<HTMLElement>('.swiper');
    if (!swiperEl) {
      return;
    }
    new Swiper(swiperEl, {
      slidesPerView: 'auto',
      speed: 1000,
      spaceBetween: 24,
      threshold: 10,
      centerInsufficientSlides: true,
      watchOverflow: true,
      modules: [SwiperModules.Navigation],
      navigation: {
        prevEl: this.$root.querySelector<HTMLElement>('.ce-page-hero-btn--prev'),
        nextEl: this.$root.querySelector<HTMLElement>('.ce-page-hero-btn--next')
      },
      on: {
        slideChange: (swiper) => {
          const video: HTMLVideoElement | null = swiper.slides[swiper.previousIndex]
            .querySelector<HTMLVideoElement>('.media-item');
          video?.closest('[x-video-player]')?.dispatchEvent(PlayerEvents.stop);
        }
      }
    });
  }
});
